export const AUTOMATION_RULE_ANALYTICS_SUBJECT = 'automationRule';

const PREFIX = 'servicedesk.automation';
export const buildAnalyticsKey = (suffix: string) => `${PREFIX}.${suffix}`;

export const transformModuleKey = (key: string): string => {
	const result = key.match(/([^:]+)$/);
	return result && result[0] ? result[0] : '';
};

/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */
const triggerAnalyticsEvent =
	(_appName: string) =>
	(_eventNameSuffix: string, _eventData: unknown): Promise<void> =>
		Promise.resolve(undefined);

const triggerAnalyticsFunction = triggerAnalyticsEvent(PREFIX);

/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (eventNameSuffix: string, data: unknown = undefined) => {
	triggerAnalyticsFunction(eventNameSuffix, data);
};
